import { currentEnv } from './detect-env'

type GooglePlacesConfig = {
  apiKey: string
}

const envConfigs: Record<string, GooglePlacesConfig> = {
  local: {
    // this key is not hard coded because it is not protected by
    // allowed origins for use in local development
    apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  },
  staging: {
    apiKey: '', // TODO: add staging key
  },
  production: {
    apiKey: 'AIzaSyC7pfbEGWC8m6SFpwPYB0EbvjqWAwi8_Y4', // TODO: add production key
  },
}

const config = envConfigs[currentEnv] ?? null

export const googlePlacesApiKey: string | null = config?.apiKey ? config.apiKey : null
export const isGooglePlacesConfigured: boolean =
  googlePlacesApiKey !== null && googlePlacesApiKey !== ''
